export default __webpack_public_path__ + "static/media/chairman-gifting-on-diwali.4a997a99.jpeg";